module.exports = __webpack_public_path__ + "resources/img/img_plantpulse_m.5eec11dac29d651d5a81cb0abd420615.png";